<template>
    <h1 class="my-3">FAQs</h1>
    <div class="row d-flex justify-content-between">
        <div class="col-12 col-md-9">
            <div class="mb-3">
                <input class="form-control" type="text" id="search" placeholder="Search" v-model="searchValue" @keyup="startSearch()">
            </div>
            <div class="accordion accordion-flush" id="faqAccordion" ref="faqParent">
                <div class="accordion-section" v-for="(array, group) in faqs">
                    <h2 class="mt-lg-4" :id="group">
                        {{ group.charAt(0).toUpperCase() + (group == 'tpms' ? group.slice(1).toUpperCase() : group.slice(1).replace(/_/g, ' ')) }}
                    </h2>
                    <div v-for="(faq, index) in array" class="accordion-item">
                        <h2 class="accordion-header" :id="'heading' + index + group">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse' + index + group" aria-expanded="false" :aria-controls="'#collapse' + index + group">
                                {{ faq.question }}
                            </button>
                        </h2>
                        <div :id="'collapse' + index + group" class="accordion-collapse collapse" :aria-labelledby="'heading' + index + group" data-bs-parent="#faqAccordion">
                            <div class="accordion-body" v-html="faq.answer"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3 d-none d-md-block">
            <div class="sticky-md-top">
                <h2>Jump to:</h2>
                <div v-for="(item, group) in faqs">
                    <a class="d-block my-3" :href="'#' + group">
                        {{ group.charAt(0).toUpperCase() + (group == 'tpms' ? group.slice(1).toUpperCase() : group.slice(1).replace(/_/g, ' ')) }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'faqs'
        ],
        data() {
            return {
                searchValue: '',
                typingTimer: ''
            }
        },
        mounted() {
            //removes loading placeholder - fixes CLS issue
            document.querySelector('#loadingPlaceholder').style.display = 'none';
        },
        methods: {
            startSearch() {
                let vm = this;
                let wrapper = document.getElementById('faqAccordion');
                this.search();

                clearTimeout();
                this.typingTimer = setTimeout(function() {vm.highlightSearchText()}, 700);

            },
            search() {
                let vm = this;
                var panels = document.getElementById('faqAccordion').getElementsByClassName('accordion-item');
                var headings = document.getElementById('faqAccordion').querySelectorAll('.accordion-section > h2');
                
                //Hide all headings as standard, then show matched heading in next loop.
                _.forEach(headings, function(heading, key) {
                    heading.style.display = 'none';
                });

                //Builds up faqText to hold all of the text from titles and paragraphs, to compare the search value against.
                _.forEach(panels, function(panel, key) {
                    //This was particularly long winded, refactor? lodash equivalents maybe?
                    let panelSection = panel.parentElement;
                    let sectionHeading = panelSection.childNodes[0];

                    let searchableText = '';
                    let button_text = panel.getElementsByClassName('accordion-header')[0].getElementsByClassName('accordion-button')[0].textContent;
                    let paragraphs = panel.getElementsByClassName('accordion-collapse')[0].getElementsByClassName('accordion-body')[0].querySelectorAll('p');
                    
                    _.forEach(paragraphs, function(paragraph, key) {
                        searchableText = searchableText + paragraph.textContent;
                    });
                    
                    searchableText = searchableText + button_text;

                    //jQuery does the above in 1 line.
                    // faq_question = $(this_child_panel).find('h3').text() + $(this_child_panel).find('p').text();

                    //Checks to see if the searchValue exists inside a panel, if it doesn't it hides that panel
                    if (searchableText.toLowerCase().includes(vm.searchValue.toLowerCase())) {
                        sectionHeading.style.display = 'block';
                        panel.style.display = "block";
                    }
                    else {
                        panel.style.display = "none";
                        // sectionHeading.style.display = 'none';
                    }
                });
            },
            highlightSearchText() {
                let vm = this;

                var context = document.querySelector('#faqAccordion');
                var instance = new Mark(context);
                instance.unmark({
                    done: function() {
                        instance.mark(vm.searchValue);
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>